<template>
    <div v-if="config['forms'] != undefined" id="container-donation-forms" class="mx-special h-full max-md:pt-special">
        <div id="banks">
            <div id="title" class="mb-special">
                <span class="font-bloggerB text-content-title-desktop max-md:text-content-title-mobile dark:text-primary-dark-text"> {{ config['texts'][0] }}</span>
            </div>
            <div v-for="acc, index in config['forms'][0]['accounts']" :id="'bank-acc' + index" class="ml-special">
                <div class="flex flex-col mb-special">
                    <span class="mb-text text-content-subtitle-desktop text-primary-text font-bloggerB max-md:text-principal-mobile">
                        {{ acc['bank'] }}
                    </span>
                    <span class="text-principal-desktop font-monserratM max-md:text-content-subtitle-mobile dark:text-primary-dark-text">
                        {{ acc['number'] }}
                    </span>
                </div>
            </div>
        </div>
        <div id="digital-wallets" class="mt-special">
            <div v-for="acc, index in config['forms'][1]['accounts']" :id="'tm-acc' + index">
                <div class="flex flex-col mb-special mx-special">
                    <span class="mb-text text-content-subtitle-desktop text-primary-text font-bloggerB max-md:text-principal-mobile">
                        {{ acc['bank'] }}
                    </span>
                    <span class="text-principal-desktop font-monserratM max-md:text-content-subtitle-mobile dark:text-primary-dark-text">
                        {{ acc['number'] }}
                    </span>
                </div>
            </div>
        </div>
        <div id="giving" class="w-full text-center mt-third">
            <span class="font-bloggerB text-primary-text text-big-text-desktop max-md:text-big-text-mobile"> {{ config['texts'][1] }}</span>
        </div>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, nextTick } from 'vue';
import { generalStore } from '@/stores';

const store = generalStore();
const route = store.route;

var config = ref({});

store.setIsPP(false);

onBeforeMount(async () => {
    window.scrollTo(top);
    await store.getConfiguration(route.name);
    await nextTick();
    config.value = store.getSessionStorage('configuration-' + route.name);
})
</script>